import { createUseStyles } from "react-jss";

export const textStyles = {

    title: {
        width: "100%",
        fontSize: "2em",
        margin: "0 0 1em 0"
    },
    titleMediumMargin: {
        width: "100%",
        fontSize: "2em",
        margin: "0 0 0.5em 0"
    },
    titleNoMargin: {
        width: "100%",
        fontSize: "2em"
    },
    bigTitle: {
        width: "100%",
        fontSize: "3em",
    },
    smallTitle: {
        width: "100%",
        fontSize: "1.5em"
    },
    subtitle: {
        width: "100%",
        fontSize: "1em",
        margin: "0 0 0.5em 0"
    },
    description: {
        width: "100%",
        fontSize: "0.8em"
    },
    annotation: {
        width: "100%",
        fontSize: "0.6em"
    },
    mediumText: {
        width: "100%",
        fontSize: "1em"
    },
    link: {
        cursor: "pointer",
        textAlign: "center",
        color: "#5F03F4",
        textDecoration: "underline",
        margin: "0.5em 0 0 0",
        fontSize: "0.8em"
    },
    alignContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    separateContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    error: { color: "#be123c" },
    left: { textAlign: "left" },
    right: { textAlign: "right" },
    center: { textAlign: "center" },
    autoWidth: { width: "unset" }
};
export const textClasses = createUseStyles(textStyles);